import slice, { fetchUser, logoutUser } from './user.slice';
export { fetchUser, logoutUser };
export default slice.reducer;
